module.exports = __webpack_public_path__ + "static/media/video.7135d67b.mp4";